import axios from 'axios';
import { useFormik } from 'formik';
import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import './MdmPolicy.scss';
//import { useToast } from '../../services/ToastContext';
import { Button, Form } from 'react-bootstrap';
import { AppAutoUpdatePolicy } from '../../enums/AppAutoUpdatePolicyEnum';
import { useToast } from '../../services/ToastContext';
import { NetworkConfiguration } from './network-configuration/NetworkConfiguration';

const initialValues = {
  defaultPermissionPolicy: '',
  uninstallAppsDisabled: false,
  factoryResetDisabled: false,
  appAutoUpdatePolicy: '',
  guid: '',
  name: '',
  type: '',
  ssid: '',
  security: '',
  autoConnect: '',
  passphrase: '',
};

/*
  remotely de-activate bluetooth and nfc on android devicespolicy name : bluetoothDisabled

for user access, bluetoothConfigDisabled
  pre-define wifi network settings on android devices: https://developers.google.com/android/management/configure-networks
  geolocation on android devices: combination of shareLocationDisabled and LocationMode
  pre-install & pre-configure applications on anroid devices 
*/

const registrationSchema = Yup.object().shape({
  defaultPermissionPolicy: Yup.string(),
  uninstallAppsDisabled: Yup.boolean(),
  factoryResetDisabled: Yup.string(),
  guid: Yup.string(),
  name: Yup.string(),
  type: Yup.string(),
  ssid: Yup.string(),
  security: Yup.string(),
  autoConnect: Yup.string(),
  passphrase: Yup.string(),
});

const AppAutoUpdatePolicyEnum: any = AppAutoUpdatePolicy;

export const MdmPolicy = () => {
  const { operatorId } = useParams();
  const { showToastMessage } = useToast();
  const toastRef: any = useRef(null);
  const networkConfigurationRef: any = useRef(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      console.log('values', values);
      setLoading(true);
      savePolicy(values);
    },
  });

  function savePolicy(values: any) {
    console.log(networkConfigurationRef.current?.formik);
    axios
      .post(`/op/ama/policy`, {policies: buildPostData(values)})
      .then((response) => {
        console.log('response', response);
        setLoading(false);
        showToastMessage('success', 'Policy saved successfully');
      })
      .catch((error) => {
        console.log('error', error);
        setLoading(false);
        showToastMessage('error', 'Error saving policy');
      });
  }

  function buildPostData(values: any) {
    return {
      policies: {
        defaultPermissionPolicy: formik.values.defaultPermissionPolicy,
        uninstallAppsDisabled: formik.values.uninstallAppsDisabled,
        factoryResetDisabled: formik.values.factoryResetDisabled,
        appAutoUpdatePolicy: formik.values.appAutoUpdatePolicy,
        openNetworkConfiguration: {
          networkConfiguration: [
            {
              guid: formik.values.guid,
              name: formik.values.name,
              type: formik.values.type,
              ssid: formik.values.ssid,
              security: formik.values.security,
              autoConnect: formik.values.autoConnect,
              passphrase: formik.values.passphrase,
            }
          ]
        }
        //wifiConfigurations: [networkConfigurationRef.current?.formik.values],
      },
    };
  }

  return (
    <section id="mdm-policy">
      {/* <ToastMessage ref={toastRef} /> */}
      <form className="form w-100 p-10" noValidate id="kt_login_signup_form" onSubmit={formik.handleSubmit}>
        <div className="register-account-content">
          <div className="description mb-5 font-bold text-lg">Mdm Android configuration:</div>

          <div>
            <label className="form-label">Default Permission Policy</label>
            <Form.Select aria-label="Default select example" {...formik.getFieldProps('defaultPermissionPolicy')}>
              <option>Open this select menu</option>
              <option value="PERMISSION_POLICY_UNSPECIFIED">PERMISSION_POLICY_UNSPECIFIED</option>
              <option value="PROMPT">PROMPT</option>
              <option value="GRANT">GRANT</option>
              <option value="DENY">DENY</option>
            </Form.Select>
          </div>

          <div className="flex items-center">
            <label className="form-label mt-2">Application Reports Enabled</label>
            <div className="flex items-start justify-start">
              <Form.Check
                inline
                label="Enabled"
                name="applicationReportsEnabled"
                onChange={() => formik.setFieldValue('applicationReportsEnabled', true)}
                type={'radio'}
              />
              <Form.Check
                inline
                label="Disabled"
                name="applicationReportsEnabled"
                onChange={() => formik.setFieldValue('applicationReportsEnabled', false)}
                type={'radio'}
              />
            </div>
          </div>

          <div className="flex items-center">
            <label className="form-label">Device Settings Enabled</label>
            <div className="flex items-start justify-start">
              <Form.Check
                inline
                label="Enabled"
                name="deviceSettingsEnabled"
                onChange={() => formik.setFieldValue('deviceSettingsEnabled', true)}
                type={'radio'}
              />
              <Form.Check
                inline
                label="Disabled"
                name="deviceSettingsEnabled"
                onChange={() => formik.setFieldValue('deviceSettingsEnabled', false)}
                type={'radio'}
              />
            </div>
          </div>

             <div className="flex items-center">
            <label className="form-label">Uninstall Apps Disabled</label>
            <div className="flex items-start justify-start">
              <Form.Check
                inline
                label="Enabled"
                name="uninstallAppsDisabled"
                onChange={() => formik.setFieldValue('uninstallAppsDisabled', true)}
                type={'radio'}
              />
              <Form.Check
                inline
                label="Disabled"
                name="uninstallAppsDisabled"
                onChange={() => formik.setFieldValue('uninstallAppsDisabled', false)}
                type={'radio'}
              />
            </div>
          </div>

          <div className="flex items-center">
            <label className="form-label">Factory Reset Disabled</label>
            <div className="flex items-start justify-start">
              <Form.Check
                inline
                label="Enabled"
                name="factoryResetDisabled"
                onChange={() => formik.setFieldValue('factoryResetDisabled', true)}
                type={'radio'}
              />
              <Form.Check
                inline
                label="Disabled"
                name="factoryResetDisabled"
                onChange={() => formik.setFieldValue('factoryResetDisabled', false)}
                type={'radio'}
              />
            </div>
          </div>
        </div>

        <div>
          <label className="form-label">App auto update policy</label>

          <Form.Select {...formik.getFieldProps('appAutoUpdatePolicy')}>
            {Object.keys(AppAutoUpdatePolicyEnum)?.map((key: any) => (
              <option key={key} value={key}>
                {AppAutoUpdatePolicyEnum[key]}
              </option>
            ))}
          </Form.Select>
        </div>

        <div className="mt-4">
          <span className="form-label">Predefine Wifi Configuration</span>
          {/*  <NetworkConfiguration ref={networkConfigurationRef}></NetworkConfiguration> */}

          <div className='flex' style={{marginLeft: '-9px'}}>
            <div className="mb-5 scale-90">
              <label className="form-label pt-5">GUID</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('guid')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">Name</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('name')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">Type</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('type')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">SSID</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('ssid')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">Security</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('security')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">AutoConnect</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('autoConnect')} />
            </div>

            <div className="mb-5 scale-90">
              <label className="form-label pt-5">Passphrase</label>
              <input type="text" autoComplete="off" {...formik.getFieldProps('passphrase')} />
            </div>
          </div>
        </div>
        <Button className="mt-4" type="submit">
          Save
        </Button>
      </form>
    </section>
  );
};
